import { useQuery } from "@tanstack/react-query";
import { inboxKeys } from "./queryKeys";
import { getActiveAccounts, listConversations } from "./api";

/** Active Unipile accounts (gates the whole inbox + drives realtime channels). */
export function useActiveInboxAccounts() {
	const query = useQuery({
		queryKey: inboxKeys.accounts(),
		queryFn: getActiveAccounts,
		staleTime: 5 * 60 * 1000,
	});
	return {
		...query,
		accounts: query.data ?? [],
		hasActiveAccounts: (query.data?.length ?? 0) > 0,
	};
}

/** All conversations across connected accounts (email, LinkedIn, WhatsApp). */
export function useConversations(enabled = true) {
	return useQuery({
		queryKey: inboxKeys.conversations(),
		queryFn: listConversations,
		enabled,
		staleTime: 30 * 1000,
		refetchOnWindowFocus: true,
	});
}
